import {
    Dialog,
    DialogTitle,
    Stack,
    IconButton,
    Typography,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Divider,
    useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { useCallback } from "react";
import CloseIcon from "@mui/icons-material/Close";
import defaultAxios, { AxiosError } from "axios";
import Swal from "sweetalert2";
import { useTransaksiStore } from "../../stores/transaksiStore";
import useDeleteItem from "../../services/mutations/useDeleteItem";

interface IModalDeleteStokProps {
    refetch: () => void;
    open: boolean;
    onClose: () => void;
    stokName: string;
    stokId: number | string | undefined;
}

const ModalDeleteStok = ({
    refetch,
    open,
    onClose,
    stokName,
    stokId,
}: IModalDeleteStokProps) => {
    const theme = useTheme();
    const isPhoneScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const handleReset = useTransaksiStore((s) => s.handleReset);
    const deleteItem = useDeleteItem();

    const handleDelete = (id: string | number | undefined) => {
        if (id === undefined) return;
        deleteItem.mutate(id, {
            onSuccess: (data) => {
                if (data.code === 200) {
                    Swal.fire({
                        title: `${stokName} berhasil dihapus!`,
                        position: "top-end",
                        showConfirmButton: false,
                        icon: "success",
                        toast: true,
                        timer: 3000,
                        timerProgressBar: true,
                        showCloseButton: true,
                        customClass: {
                            container: "my-swal",
                        },
                    });
                    handleReset();
                    refetch();
                }
                onClose();
            },
            onError: (error) => {
                handleErrorResponse(error);
            },
        });
    };

    const handleErrorResponse = useCallback(
        (error) => {
            if (defaultAxios.isAxiosError(error)) {
                const serverError = error as AxiosError<any>;
                if (serverError && serverError.response) {
                    Swal.fire({
                        title: "Terjadi Kesalahan!",
                        text: `${serverError.response.data.message}`,
                        icon: "error",
                        confirmButtonColor: "#45A779",
                        customClass: {
                            container: "my-swal",
                        },
                    });
                    onClose();
                } else {
                    Swal.fire({
                        title: "Terjadi Kesalahan!",
                        text: `Telah Terjadi Kesalahan`,
                        icon: "error",
                        confirmButtonColor: "#45A779",
                        customClass: {
                            container: "my-swal",
                        },
                    });
                    onClose();
                }
            }
        },
        [onClose],
    );

    return (
        <Dialog
            maxWidth="xs"
            fullWidth={true}
            fullScreen={isPhoneScreen}
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    //   minHeight: "150px",
                    //   maxHeight: "150px",
                    borderRadius: 1,
                },
            }}
        >
            <DialogTitle>
                <Stack 
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={1}
                >
                    <Typography variant="h6" fontWeight="bold">
                        Hapus Barang
                    </Typography>

                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Stack>
            </DialogTitle>

            <Divider />

            <DialogContent>
                <DialogContentText>
                    Barang {stokName} akan dihapus secara permanen. Yakin ingin
                    menghapus?
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ padding: 2 }}>
               
                <Button
                    variant="outlined"
                    onClick={onClose}
                    color="error"
                >
                    Tidak
                </Button>

                <Button
                    variant="contained"
                    onClick={() => handleDelete(stokId)}
                    color="error"
                >
                    Hapus
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ModalDeleteStok;
